import React from 'react';
import { inject, observer } from 'mobx-react';
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { Button, NoData } from 'oned';
import { AmplitudeEventName, ProblemLevel } from '@common/enums/base';
import classnames from 'classnames';
import { getCurrentEnv, sendAmplitude_Default } from '@common/utils';
import Cookies from "js-cookie";
var LevelTwo = inject(ProblemBusiness)(observer(function (props) {
    var setProblemLevel = props.setProblemLevel, levelOneName = props.levelOneName, levelTwoAliasList = props.levelTwoAliasList, levelOneTwoId = props.levelOneTwoId, getServiceComboAlias = props.getServiceComboAlias, setProblemAlias = props.setProblemAlias, currentUser = props.currentUser, problemCaseCadeName = props.problemCaseCadeName, setLastLevel = props.setLastLevel, serviceCodeCheck = props.serviceCodeCheck, isAliasingView = props.isAliasingView, clearCommonStoreKeepStatus = props.clearCommonStoreKeepStatus;
    var setLevel = function (alias) {
        var clearAfterStepData = props.clearAfterStepData;
        setProblemAlias(alias, ProblemLevel.LevelTwo);
        clearAfterStepData();
        if (!alias.isLeafNode) {
            setProblemLevel(ProblemLevel.LevelThree);
            setLastLevel(ProblemLevel.LevelTwo);
            getServiceComboAlias(ProblemLevel.LevelThree, alias.id);
        }
        else {
            clearCommonStoreKeepStatus();
            serviceCodeCheck(alias);
            sendAmplitude_Default(AmplitudeEventName.NewRSP_Step1to2, {
                userId: currentUser.userId,
                residentId: currentUser.residentId,
                problemLevel1: levelOneName,
                problemLevel2: alias.name,
                problemLevel3: '',
                serviceCombo: problemCaseCadeName,
                clientId: Cookies.get('clientId'),
                env: getCurrentEnv(),
            });
        }
    };
    return React.createElement("div", null,
        React.createElement("div", { className: 'row mt-4' },
            React.createElement("div", { className: 'col-12' },
                React.createElement("h2", { className: 'problem-title' },
                    React.createElement("b", null, isAliasingView ? "What is within the " + levelOneName.toLocaleLowerCase() + "?" : 'Service type')))),
        React.createElement("div", { className: 'row' },
            levelTwoAliasList.length > 0 && levelTwoAliasList.map(function (alias) { return (React.createElement("div", { className: 'col-md-6 col-xs-12' },
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14', alias.id === levelOneTwoId && 'active'), onClick: function () { return setLevel(alias); } }, alias.name))); }),
            !levelTwoAliasList || levelTwoAliasList.length === 0 &&
                React.createElement("div", { className: 'w-100 d-flex justify-content-center' },
                    React.createElement(NoData, null))));
}));
export default LevelTwo;
